import { render, staticRenderFns } from "./Framabee.vue?vue&type=template&id=1eeeefe4&"
import script from "./Framabee.vue?vue&type=script&lang=js&"
export * from "./Framabee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports